import { toStrippedCase } from './helpers'

const getMembersFromGroupName = (donors, name) => (
  donors.filter(donor => donor.groups.map(toStrippedCase).includes(toStrippedCase(name)))
)

export default getMembersFromGroupName
